import { SpecialOpeningHours } from "@greeter/core";
import { classNames } from "@greeter/util";
import { Props } from "@greeter/matter";
import { SpecialOpeningHoursInput } from "../SpecialOpeningHoursInput/SpecialOpeningHoursInput";
import { trashOutline } from "ionicons/icons";
import { IonIcon } from "@ionic/react";
import { DatePeriod, TimeOfDay, withTimeOfDay } from "@greeter/date";
import { last } from "lodash";
import { addDays } from "date-fns";

import css from "./MultiSpecialOpeningHoursInput.module.scss";

export type MultiSpecialOpeningHoursInputProps = Props & {
  value: SpecialOpeningHours[];
  onChange: (specialOpeningHours: SpecialOpeningHours[]) => void;
  mode?: "all" | "previous" | "future";
  theme?: "dark" | "light";
};

export function MultiSpecialOpeningHoursInput(
  props: MultiSpecialOpeningHoursInputProps
) {
  return (
    <div {...classNames(css.MultiSpecialOpeningHoursInput)}>
      {props.value.map((soh, j) => {
        return (
          <div key={soh.id} className={css.Item}>
            <div className={css.EditBar}>
              <IonIcon
                icon={trashOutline}
                style={{ color: "white" }}
                onClick={() => {
                  props.onChange(props.value.filter((_soh) => _soh !== soh));
                }}
              />
            </div>
            <SpecialOpeningHoursInput
              theme={props.theme}
              value={soh}
              onChange={(changedSoh) => {
                const updated = props.value.map((_soh, i) =>
                  j === i ? changedSoh : _soh
                );
                props.onChange(updated);
              }}
            />
          </div>
        );
      })}

      <button
        className={css.AddButton}
        onClick={() => {
          const value = props.value;
          const lastOpeningHours = last(value);
          const from = lastOpeningHours
            ? TimeOfDay.fromDate(lastOpeningHours.period.from)
            : TimeOfDay.parse("00:00");
          const to = lastOpeningHours
            ? TimeOfDay.fromDate(lastOpeningHours.period.to)
            : TimeOfDay.parse("23:59");

          const fromDate = withTimeOfDay(
            addDays(lastOpeningHours?.period.from ?? new Date(), 1),
            from
          );
          const toDate = withTimeOfDay(fromDate, to);
          let period: DatePeriod;
          try {
            period = new DatePeriod({
              from: fromDate,
              to: toDate,
            });
          } catch {
            period = new DatePeriod({
              from: fromDate,
              to: addDays(toDate, 1),
            });
          }
          const newPeriod = {
            id: "", // This doesnt seem to do anything
            period: period,
          };
          const result = Array.from(value).concat([newPeriod]);
          props.onChange(result);
        }}
      >
        + Ny speciel åbningstid
      </button>
    </div>
  );
}
